// extracted by mini-css-extract-plugin
export var aggregationCell = "_2q-p";
export var aggregationRow = "_2q-o";
export var borderlessSpinnerContainer = "_2q-3";
export var cardLayout = "_2q-6";
export var cardLayoutNoFooter = "_2q-a";
export var cardLayoutPageControl = "_2q-9";
export var cardLayoutWithFooter = "_2q-8";
export var closeIcon = "_2q-h";
export var columnHeaderSurface = "_2q-d";
export var columnHeaderSurfaceDragOverlay = "_2q-x";
export var columnHeaderSurfaceResizing = "_2q-u";
export var contextMenuAnchor = "_2q-1";
export var draggableColumnHeader = "_2q-v";
export var draggableColumnHeaderOverlay = "_2q-w";
export var expandIcon = "_2q-i";
export var expanded = "_2q-j";
export var filterDropdown = "_2q-k";
export var filterDropdownDivider = "_2q-f";
export var filterDropdownHeader = "_2q-n";
export var filterDropdownItem = "_2q-m";
export var filterDropdownModal = "_2q-l _2q-k";
export var filterItem = "_2q-e";
export var normalCellWithAdjustableBorder = "_2q-g";
export var pinButtonContainer = "_2q-q";
export var pinIcon = "_2q-r";
export var pinIconActive = "_2q-s";
export var spinner = "_2q-0";
export var spinnerContainer = "_2q-2";
export var tableContainer = "_2q-4";
export var tableContentDraggingColumns = "_2q-c";
export var tableContentInner = "_2q-7";
export var tableContentInnerFill = "_2q-b";
export var tableContentWrapper = "_2q-5";
export var viewButtonContainer = "_2q-t";